import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { EllipsisIcon } from 'lucide-react'
import { Typography } from '@/components/ui/typography'
import { useTranslation } from '@pancakeswap/localization'
import { Button } from '@/components/ui/button'
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer'
import { useMediaQuery } from '@/hooks/use-media-query'
import { ThemeSelector } from '@/components/theme-selector'

enum SlippageError {
  InvalidInput = 'InvalidInput',
  RiskyLow = 'RiskyLow',
  RiskyHigh = 'RiskyHigh',
}

enum DeadlineError {
  InvalidInput = 'InvalidInput',
}

const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`) // match escaped "." characters via in a non-capturing group
const THREE_DAYS_IN_SECONDS = 60 * 60 * 24 * 3
const TOLERANCES = [10, 50, 100]

export const GlobalSettingsPopover = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)')

  if (isDesktop) {
    return (
      <>
        <Popover>
          <PopoverTrigger>
            <Button variant={'ghost'} className={'rounded-full aspect-square px-2!'}>
              <EllipsisIcon className={'size-5 cursor-pointer'} />
            </Button>
          </PopoverTrigger>
          <PopoverContent align={'center'} onOpenAutoFocus={(e) => e.preventDefault()}>
            <GlobalSettingsForm />
          </PopoverContent>
        </Popover>
      </>
    )
  }

  return (
    <>
      <Drawer>
        <DrawerTrigger asChild>
          <Button variant={'ghost'} className={'rounded-full aspect-square px-2!'}>
            <EllipsisIcon className={'size-5 cursor-pointer'} />
          </Button>
        </DrawerTrigger>
        <DrawerContent>
          <div className="px-6 py-12">
            <GlobalSettingsForm />
          </div>
        </DrawerContent>
      </Drawer>
    </>
  )
}

const GlobalSettingsForm = () => {
  const { t } = useTranslation()

  return (
    <>
      <Typography className={'mb-4 font-semibold'}>Global Settings</Typography>
      <div className="flex items-center justify-between">
        <div>{t('Theme')}</div>
        <ThemeSelector />
      </div>
    </>
  )
}
